import React from 'react';
import { Stack } from '@mui/material';
import { IconLibrary, PermissionIconButton } from '@product-framework/index';
import {
  formatUSPhoneNumber,
  getSMSSubscriptionAttributes,
  InsightChipWithToolTip,
} from '@product-framework/components/FormFields/PhoneNumber';
import { useLocalization } from '@ui-framework/index';

function phoneNumber(row, _props, additional) {
  const { formatMessage } = useLocalization();
  const { saPhoneNumber, insightPurchased } = additional || {};
  const formattedPhoneNumber = formatUSPhoneNumber(row?.phoneNumber);
  const status = row?.smsSubscriptionStatus;

  if (!insightPurchased || !status) {
    return formattedPhoneNumber;
  }

  return (
    <Stack direction="row" alignItems="center" flexWrap="nowrap">
      {formattedPhoneNumber}
      <InsightChipWithToolTip
        sx={{ ml: 1 }}
        status={getSMSSubscriptionAttributes(
          status,
          saPhoneNumber,
          formatMessage,
        )}
      />
    </Stack>
  );
}

function description(row) {
  return row?.description;
}

function isVoiceEnabled(row, _props, additional) {
  const { formatMessage } = additional || {};

  return row?.isVoiceEnabled === true
    ? formatMessage({
        id: 'ENABLED',
        defaultMessage: 'Enabled',
      })
    : formatMessage({
        id: 'DISABLED',
        defaultMessage: 'Disabled',
      });
}

function isVoiceDefault(row, _props, additional) {
  const { formatMessage } = additional || {};

  return row?.isVoiceDefault === true
    ? formatMessage({
        id: 'YES',
        defaultMessage: 'Yes',
      })
    : formatMessage({
        id: 'NO',
        defaultMessage: 'No',
      });
}

function isTextEnabled(row, _props, additional) {
  const { formatMessage } = additional || {};

  return row?.isTextEnabled === true
    ? formatMessage({
        id: 'OPTED_IN',
        defaultMessage: 'Opted-in',
      })
    : formatMessage({
        id: 'OPTED_OUT',
        defaultMessage: 'Opted-out',
      });
}

function isTextDefault(row, _props, additional) {
  const { formatMessage } = additional || {};

  return row?.isTextDefault === true
    ? formatMessage({
        id: 'YES',
        defaultMessage: 'Yes',
      })
    : formatMessage({
        id: 'NO',
        defaultMessage: 'No',
      });
}

function actions(row, _props, additional) {
  const { onEdit, onDelete } = additional || {};

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <PermissionIconButton
        permissionName="CAN_UPDATE_SP_INSIGHT_CONTACTS"
        size="small"
        sx={{ p: 0.25, minWidth: 28 }}
        onClick={() => onEdit?.(row)}>
        <IconLibrary.FormChanged fontSize="small" />
      </PermissionIconButton>
      <PermissionIconButton
        permissionName="CAN_UPDATE_SP_INSIGHT_CONTACTS"
        size="small"
        color="error"
        sx={{ p: 0.25, minWidth: 28 }}
        onClick={() => onDelete?.(row)}>
        <IconLibrary.Delete fontSize="small" />
      </PermissionIconButton>
    </Stack>
  );
}

export {
  phoneNumber,
  description,
  isVoiceEnabled,
  isVoiceDefault,
  isTextEnabled,
  isTextDefault,
  actions,
};
